export default "__VITE_ASSET__Bk5SENpz__"